import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appTogglePassword]',
    standalone: false
})
export class TogglePasswordDirective {

  readonly WRAP_CLASS_NAME = 'wrap-input-password';
  readonly WRAP_ICON_CLASS_NAME = 'wrap-icon-input-password';
  readonly ICON_CLASS_NAME = 'icon-input-password';
  readonly CLASS_NAME_HIDDEN_ICON = 'fa-eye-slash';
  readonly CLASS_NAME_SHOW_ICON = 'fa-eye';

  wrapper: any;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.handler();
  }

  handler(): void {
    this.createWrapper();
    this.insertInputInWrapper();
    this.insertIcon();
  }

  createWrapper(): void {
    const div = this.renderer.createElement('div');
    div.classList.add(this.WRAP_CLASS_NAME);

    this.wrapper = div;
  }

  insertInputInWrapper(): void {
    const el = this.elementRef.nativeElement;
    const parent = el.parentNode;
    this.renderer.insertBefore(parent, this.wrapper, el);

    this.renderer.appendChild(this.wrapper, el);
  }

  insertIcon(): void {
    const wrapIcon = this.renderer.createElement('span');
    wrapIcon.classList.add(this.WRAP_ICON_CLASS_NAME);

    const icon = this.renderer.createElement('i');
    icon.classList.add('fas');
    icon.classList.add(this.CLASS_NAME_HIDDEN_ICON);
    icon.classList.add(this.ICON_CLASS_NAME);
    wrapIcon.addEventListener('click', () => {
      this.toggle(icon, wrapIcon);
    });

    this.renderer.appendChild(wrapIcon, icon);

    this.renderer.appendChild(this.wrapper, wrapIcon);
  }

  toggle(icon: HTMLElement, wrapIcon: HTMLElement): void {
    icon.classList.toggle(this.CLASS_NAME_HIDDEN_ICON);
    icon.classList.toggle(this.CLASS_NAME_SHOW_ICON);
    wrapIcon.innerHTML = '';
    this.renderer.appendChild(wrapIcon, icon);


    const input = this.getInputFromWrapIcon(wrapIcon);
    this.toggleInput(input);
  }

  isHiddenMode(icon: HTMLElement): boolean {
    return icon.classList.contains(this.CLASS_NAME_HIDDEN_ICON);
  }

  getInputFromWrapIcon(wrapIcon: HTMLElement): HTMLElement {
    return wrapIcon.previousElementSibling as HTMLElement;
  }

  toggleInput(input: HTMLElement): void {
    input.getAttribute('type') === 'password' ? input.setAttribute('type', 'text') : input.setAttribute('type', 'password');
  }
}
